<script>

import { onMount } from 'svelte';
import Icon from './Icon.svelte';

let { title, icon = null } = $props();

let heading;

/* Focus heading on mount so screen readers announce the new page title on route changes */
onMount(() => {
    heading?.focus();
});

</script>

<header>
    <div class="title">
        <h1 bind:this={heading} tabindex="-1">{title}</h1>
        {#if icon}
            <span class="title-icon"><Icon data={icon} size="1.6em" /></span>
        {/if}
    </div>
</header>

<style>

    header {
        grid-row: 1;
        padding: 4em 0 0;

        display: flex;
        flex-direction: row;
        align-items: flex-end;
        justify-content: space-between;
    }

    .title {
        display: flex;
        align-items: center;
        gap: 0.5em;
    }

    /* Light-grey accent icon after the title (e.g. the AI icon on the chat). Its own
       opacity matches the faded title, and currentColor adapts to light/dark mode. */
    .title-icon {
        display: inline-flex;
        color: var(--text-color);
        opacity: 0.35;
    }

    header h1:focus {
        outline: none;
    }

    header h1 {
        font-family: var(--theme-alt-font-family);
        font-weight: var(--theme-font-weight);
        font-size: 3.2em;
        margin: 0;
        opacity: 0.3;
    }

</style>